<template>
    <div class="form">
        <div class="form-row">
            <div class="form-row__col form-row__col--one-half">
                <v-select
                    v-model="filter.filterByClient"
                    :placeholder="this.trans('users.label.client')"
                    :options="this.clients"
                    :disabled="this.clients.length == 1"
                    @input="clientFilterChanged"
                    class="form-vue-select"
                >
                    <div slot="no-options">
                        {{ trans('vue_select.no_options') }}
                    </div>
                </v-select>
            </div>

            <div class="form-row__col form-row__col--one-half">
                <v-select
                    v-model="filter.filterByCourse"
                    :placeholder="this.trans('courses.label.courses')"
                    :options="this.courses"
                    :disabled="this.courses.length == 1"
                    @input="emitFilterChangedEvent"
                    class="form-vue-select"
                >
                    <div slot="no-options">
                        {{ trans('vue_select.no_options') }}
                    </div>
                </v-select>
            </div>
        </div>
        <div class="form-row" v-if="this.filteredUsergroups.length">
            <div class="form-row__col form-row__col--one-half">
                <v-select
                    v-model="filter.filterByUsergroup"
                    :placeholder="this.trans('reporting.label.usergroup')"
                    :options="this.filteredUsergroups"
                    @input="emitFilterChangedEvent"
                    class="form-vue-select"
                >
                </v-select>
            </div>
        </div>

        <div class="form-row">
            <div class="form-row__col form-row__col--one-half">
                <select
                    name="statusFilter"
                    @change="updateStatusSelect"
                    id="statusFilter"
                    class="form-select"
                    v-model="statusSelect"
                >
                    <option value="all" default>
                        {{ trans('reporting.readable_status.all') }}
                    </option>
                    <option value="completed">
                        {{ trans('reporting.readable_status.completed') }}
                    </option>
                    <option value="not-done">
                        {{ trans('reporting.readable_status.not-done') }}
                    </option>
                    <option value="overdue">
                        {{ trans('reporting.readable_status.overdue') }}
                    </option>
                    <option value="not_assigned">
                        {{ trans('reporting.readable_status.not_assigned') }}
                    </option>
                </select>
            </div>

            <div class="form-row__col form-row__col--one-half">
                <select
                    name="activeFilter"
                    @change="emitFilterChangedEvent"
                    id="activeFilter"
                    class="form-select"
                    v-model="filter.filterByActive"
                >
                    <option value="all" default>
                        {{ trans('reporting.active.all') }}
                    </option>
                    <option value="only-active">
                        {{ trans('reporting.active.only-active') }}
                    </option>
                    <option value="only-inactive">
                        {{ trans('reporting.active.only-inactive') }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';
import { getDefaultFilterData } from './partials/getDefaultFilterData';

export default {
    props: [],
    data() {
        return {
            filter: getDefaultFilterData(),
            clients: [],
            courses: [],
            usergroups: [],
            statusSelect: 'all',
        };
    },
    computed: {
        filteredUsergroups() {
            const { filterByClient } = this.filter;
            if (!filterByClient) {
                return [];
            }
            // Quite simple approach, this does not include children client's usergroups
            return this.usergroups.filter(
                usergroup => usergroup.client_id === filterByClient.id
            );
        },
    },
    methods: {
        updateStatusSelect() {
            switch (this.statusSelect) {
                case 'all':
                    this.filter.status = getDefaultFilterData().status;
                    break;
                case 'not-done':
                    this.filter.status = ['overdue', 'pending', 'processing'];
                    break;
                default:
                    this.filter.status = [this.statusSelect];
                    break;
            }

            this.emitFilterChangedEvent();
        },
        emitFilterChangedEvent() {
            EventBus.$emit('filterChanged', { filter: this.filter });
        },
        clientFilterChanged() {
            this.filter.filterByUsergroup = null;
            this.emitFilterChangedEvent();
        },
        fetchData() {
            axios
                .get(this.route('tenantapi.reporting.filter'))
                .then(({ data }) => {
                    this.clients = data.clients.map(client => {
                        return {
                            id: client.id,
                            label: client.prefixed_name,
                            ...client,
                        };
                    });
                    if (this.clients.length === 1) {
                        this.filter.filterByClient = this.clients[0];
                    }

                    this.courses = data.courses.map(course => {
                        return {
                            id: course.id,
                            label: course.title,
                            ...course,
                        };
                    });

                    this.usergroups = data.usergroups.map(usergroup => {
                        return {
                            id: usergroup.id,
                            label: usergroup.name,
                            ...usergroup,
                        };
                    });
                });
        },
    },

    mounted() {
        this.fetchData();

        EventBus.$on('databaseChanged', () => {
            this.filter = getDefaultFilterData();
            this.statusSelect = 'all';
            this.fetchData();
        });
    },
};
</script>
